import React from 'react';

import classNames from 'classnames';

import IconButton from 'components/inputs/basic/Button/IconButton';
import CenterIcon from 'components/primitives/icons/CenterIcon/CenterIcon';

import styles from './FlowchartControls.module.css';

interface Props {
  className?: string;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetView: () => void;
}

const FlowchartControls = (props: Props) => {
  const { className, onZoomIn, onZoomOut, onResetView } = props;
  const buttonClass = '!px-[10px] !py-[6px]';
  return (
    <div className={classNames(styles.controls, className)}>
      <IconButton
        variant="lightDullAction"
        size="form"
        icon="ZoomIn"
        iconSize={20}
        className={buttonClass}
        text="Zoom in"
        textSrOnly
        onClick={onZoomIn}
      />
      <IconButton
        variant="lightDullAction"
        size="form"
        icon="ZoomOut"
        iconSize={20}
        className={buttonClass}
        text="Zoom out"
        textSrOnly
        iconLast
        onClick={onZoomOut}
      />
      <IconButton
        variant="lightDullAction"
        size="form"
        customIcon={CenterIcon}
        iconSize={20}
        className={buttonClass}
        text="Reset graph view"
        textSrOnly
        onClick={onResetView}
      />
    </div>
  );
};

export default FlowchartControls;
